import {connect} from 'react-redux';
import SearchResult from './SearchResult.jsx';

const mapStateToProps = state => ({
  source: state.admin.home.searchResult
});

export default connect(mapStateToProps)(SearchResult);



// WEBPACK FOOTER //
// ./src/features/admin/home/SearchResultContainer.jsx